import { FC } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';

import { FLButton } from '../button';
import { Modal, closeModal } from './index';

import { useAppDispatch } from '@shared/model';
import {
  buttonsContainerStyle,
  cancelButtonClasses,
  confirmButtonClasses,
  iconStyle,
} from './ConfirmationModal.tailwind';

interface PropsType {
  title: string;
  message: string;
  onConfirm: () => void;
}

const ConfirmationModal: FC<PropsType> = ({ title, message, onConfirm }) => {
  const dispatch = useAppDispatch();

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleConfirm = () => {
    onConfirm();
    handleCloseModal();
  };

  return (
    <Modal title={title}>
      <p className="flex">
        <span>
          <AiOutlineWarning className={iconStyle} />
        </span>

        {message}
      </p>
      <div className={buttonsContainerStyle}>
        <FLButton
          type="primary"
          text="Cancel"
          onClick={handleCloseModal}
          classes={cancelButtonClasses}
          data-id="button-Cancel"
        />
        <FLButton type="primary" text="OK" onClick={handleConfirm} classes={confirmButtonClasses} data-id="button-Ok" />
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
